import { useMemo } from 'react';
var timerDebounceIds = [];
var debounce = function (callback, time) {
    return function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        clearTimeout(timerDebounceIds[callback.name]);
        timerDebounceIds[callback.name] = setTimeout(function () {
            callback.apply(void 0, arg);
        }, time);
    };
};
export var useDebounce = function (callback, timer) {
    return useMemo(function () { return debounce(callback, timer); }, [callback, timer]);
};
